/**
 * Navigation singleton usable outside React components (e.g. apiFetch).
 * App.tsx registers the navigate function once BrowserRouter is mounted.
 */
type NavigateFn = (to: string, options?: { replace?: boolean }) => void;

let _navigate: NavigateFn | null = null;

export function registerNavigate(fn: NavigateFn) {
  _navigate = fn;
}

export function navigateTo(to: string, options?: { replace?: boolean }) {
  if (_navigate) {
    _navigate(to, options);
  } else {
    // Fallback before router mounts (should not happen in practice)
    window.location.href = to;
  }
}
